import React, { Component } from 'react'
import { Row, Col, Statistic, Spin, Icon, Table, Modal, Radio } from 'antd'
import mockjs from 'mockjs'
import echarts from 'echarts'
import { api, app } from '../../app'
import asyncComponent from '../../components/asyncComponent'
import BigDataFilter from '../../components/BigDataFilter2'
import utils from "../../utils"

const BarReact = asyncComponent(() => import('../../components/Echarts'))  //柱形图组件
const provinces = ['中国', '上海', '云南', '内蒙古', '北京', '吉林', '四川', '天津', '宁夏', '安徽', '山东', '山西', '广东', '广西', '新疆', '江苏', '江西', '河北', '河南', '浙江', '海南', '湖北', '湖南', '甘肃', '福建', '西藏', '贵州', '辽宁', '重庆', '陕西', '青海', '黑龙江', '香港', '澳门', '台湾']
const charts = []
const RadioGroup = Radio.Group
// const colors = [
//     "#2B8012", "#1D8873", "#607915", "#3FB11D", "#34C0A4", "#9CBE36", "#86DB6C", "#87F0DB", "#C6DE80", "#E5E95B",
//     "#4192EC", "#286DBA", "#0B6F7A", "#3AA2D1", "#4C80BA", "#129E99", "#9EC4EE", "#80ABDB", "#57D6E7", "#AA8DEC",
//     "#CC49A7", "#E2317E", "#A6187E", "#EE86B3", "#FDB0FF", "#BC5CA1", "#C66CC9", "#FF992C", "#FFB362", "#FFD894",
//     "#E42929", "#C10C0C", "#8E0606", "#C84444", "#9C4A4A", "#641D1D", "#FF6464", "#FFA7A7", "#FFCFCF", "#634343"
// ]

/**
 * 渐变颜色
 * @param startRGB
 * @param endRGB
 * @param step
 * @returns {Array}
 */
function gradientColor(startRGB, endRGB, step) {
    let startR = startRGB[0]
    let startG = startRGB[1]
    let startB = startRGB[2]

    let endR = endRGB[0]
    let endG = endRGB[1]
    let endB = endRGB[2]

    let sR = (endR - startR) / step//总差值
    let sG = (endG - startG) / step
    let sB = (endB - startB) / step
    let colorArr = []
    for (let i = 0; i < step; i++) {
        colorArr.push('rgb(' + parseInt((sR * i + startR)) + ',' + parseInt((sG * i + startG)) + ',' + parseInt((sB * i + startB)) + ')')
    }
    return colorArr
}

/**
 * 检查类型
 * @param type
 * @returns {string}
 */
function checkType(type) {
    switch (type) {
        case 1:
            return "国"
        case 2:
            return "省"
        case 3:
            return "队"
    }
}

/**
 * 生成单条柱形图表
 */
function generateSingleStripChart(info = [], unit, title, min = 1) {
    let options = {
        // tooltip: {
        //     trigger: "axis",
        //     axisPointer: {
        //         type: 'none'
        //     }
        // },
        tooltip: {},
        legend: {
            data: (info || []).map(item => {
                return { name: item.name, icon: 'pin' }
            }),
            left: 0,
            bottom: 0,
            textStyle: {
                fontSize: 12,
            },
            selectedMode: false,
            formatter: (name) => {
                let obj = info.find(item => item.name === name) || {}
                return `${name}：${app.IntegerFormat(obj.value) + unit}`
            }
        },
        xAxis: {
            type: 'value',
            show: false,
        },
        yAxis: {
            type: 'category',
            show: false,
            data: ['比例'],
            minInterval: min
        },
        grid: {
            width: '100%',
            height: 40,
            top: 40,
            backgroundColor: '#ffffff',
            left: 'center',
            right: 0
        },
        series: (info || []).map(item => {
            const serie = {
                data: [parseFloat(item.value)],
                name: item.name,
                stack: 'one',
                type: 'bar',
                itemStyle: {
                    color: item.color
                },
                tooltip: {
                    formatter: '{a}：{c}人'
                }
            }
            if (item.id) serie.id = item.id
            return serie
        }),
    }
    if (title) {
        options.title = {
            text: title,
            textStyle: {
                color: '#444',
                fontSize: 14,
                fontWeight: 'normal',
            },
            padding: 0,
            top: 10,
        }
    }
    return options
}

/**
 * 生成X方向柱形图表
 */
function generateXBarChart(info = []) {
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            show: false,
            type: 'value',
            boundaryGap: [0, '40%']
        },
        yAxis: {
            show: false,
            type: 'category',
            axisLabel: {
                show: false,
            },
            data: (info || []).map(t => t.name),
        },
        grid: {
            left: '3%',
            right: '4%',
            top: '3%',
            height: '97%',
            containLabel: true,
            backgroundColor: '#ffffff',
        },
        series: [{
            data: (info || []).map(t => parseFloat(t.value)),
            name: '服务时长',
            type: 'bar',
            label: {
                show: true,
                position: 'right',
                formatter: '{b} {c}时',
                fontSize: 12,
                color: '#333'
            },
            itemStyle: {
                color: '#4FBDAA'
            },
            tooltip: {
                formatter: '{b}：{c}时'
            }
        }],
    }
    return options
}

/**
 * 生成单条折线图形
 * @param info
 * @returns {{xAxis: {type: string, data: any[]}, yAxis: {type: string}, series: {data: any[], type: string, smooth: boolean}[]}}
 */
function generateSingleLineChart(info = []) {
    return {
        tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {},
        },
        grid: {
            top: '6%',
            right: '6%',
            width: '80%',
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: (info || []).map(t => t.name),
            axisLabel: {
                interval: 0,
                color: '#A59EC1',
                rotate: 20
            },
            axisTick: {
                show: true,
                color: '#A59EC1',
            },
            axisLine: {
                lineStyle: {
                    color: '#A59EC1'
                }
            }
        },
        yAxis: {
            type: 'value',
            min: 0,
            minInterval: 1,
            axisLine: {
                lineStyle: {
                    color: '#A59EC1'
                }
            },
        },
        series: [{
            data: (info || []).map(t => t.value),
            type: 'line',
            smooth: true,
            lineStyle: {
                color: 'rgba(157,231,206,.6)',
                shadowBlur: 20,
                shadowColor: 'rgba(0, 0, 0, 0.2)'
            },
            itemStyle: {
                color: 'rgba(157,231,206,1)',
                borderColor: 'rgba(157,231,206,1)',
            },
            areaStyle: {
                color: 'rgba(157,231,206,.2)'
            }
        }]
    }
}

/**
 * 生成性别多条柱形图表
 */
function generateSexMiltipleStripChart(info = []) {
    const items = [
        { name: '女性', key: 'women_total', color: '#ED85BF' },
        { name: '男性', key: 'men_total', color: '#6DB3E3' },
        { name: '合共', key: 'total', color: '#63DF6F' }
    ]
    let options = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: 'shadow'
            }
        },
        backgroundColor: '#ffffff',
        grid: {
            left: '20%',
            top: '20%',
            right: '3%',
            bottom: '10%',
        },
        legend: {
            data: (items || []).map(t => {
                return { name: t.name, icon: 'pin' }
            }),
            left: 'center',
            top: '3%'
        },
        xAxis: {
            axisTick: {
                show: true,
                lineStyle: {
                    color: 'rgba(138,147,165,0.4)'
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(138,147,165,0.4)'
                }
            },
            axisLabel: {
                color: '#8A93A5',
                interval: 0,
                align: 'center'
            },
            data: (info || []).map(item => item.name),
        },
        yAxis: {
            type: 'value',
            minInterval: 1,
            min: 0,
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            splitLine: {
                lineStyle: {
                    color: 'rgba(138,147,165,0.4)'
                }
            },
            axisLabel: {
                color: '#8A93A5',
            },
        },
        series: (items || []).map(t => {
            return {
                name: t.name,
                type: 'bar',
                barWidth: '20%',
                data: (info || []).map(n => {
                    return parseInt(n[t.key])
                }),
                itemStyle: {
                    color: t.color,
                    shadowBlur: 20,
                    shadowColor: 'rgba(0, 0, 0, 0.4)',
                    barBorderRadius: [4, 4, 0, 0]
                },
                barGap: "1%",
            }
        })
    }
    return options
}

/**
 * 生成实心圆图表
 */
function generateSolidCircleChart(info = [], unit, title) {
    let options = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: 'none'
            }
        },
        backgroundColor: '#fff',
        legend: {
            data: (info || []).map(item => {
                return { name: item.name, icon: 'pin' }
            }),
            left: 'center',
            top: '3%',
            textStyle: {
                fontSize: 12,
            },
            formatter: (name) => {
                let obj = info.find(item => item.name === name) || {}
                return `${name} ${obj.value} ${unit}`
            }
        },
        series: [
            {
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: (info || []).map(item => {
                    return {
                        name: item.name,
                        value: parseFloat(item.value),
                        itemStyle: {
                            color: item.color
                        }
                    }
                }),
                itemStyle: {
                    shadowBlur: 20,
                    shadowColor: 'rgba(0, 0, 0, 0.4)'
                },
                labelLine: {
                    length: 10,
                    length2: 10
                },
                label: {
                    show: true,
                    color: '#8A93A5',
                    formatter: '{b} {d}%',
                    verticalAlign: 'top',
                    fontWeight: 'bolder',
                    textShadowBlur: 6,
                    textShadowColor: 'rgba(0, 0, 0, 0.4)'
                }
            }
        ],
    }
    if (title) {
        options.title = {
            text: title,
            textStyle: {
                color: '#444',
                fontSize: 14,
                fontWeight: 'normal',
            },
            padding: 0,
            top: 10,
        }
    }
    return options
}

/**
 * 生成普通地图图表
 */
function generateMapChart(province) {
    let options = {
        geo: {
            show: true,
            map: province,
            zoom: 1.2,
            roam: true,
            scaleLimit: {
                min: 1,
                max: 3,
            },
            label: {
                show: true,
                textStyle: {
                    color: '#666', //地图初始化区域字体颜色
                    fontSize: 10,
                    backgroundColor: 'rgba(0,0,0,0)',

                },
            },
            itemStyle: {
                color: '#CAD9E8',
                opacity: 1,
                borderWidth: 1,
                borderColor: '#0765A2',
                shadowColor: 'rgba(0,0,0,.2)',
                shadowBlur: 50
            },
            emphasis: { //当鼠标放上去  地区区域是否显示名称
                label: {
                    show: true,
                    textStyle: {
                        fontSize: 12,
                    },
                    itemStyle: {
                        color: '#0765A2'
                    }
                }
            }
        },
    }
    return options
}

/**
 * 党员分布图
 * @param info
 */
function generatePartyChart(info) {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        grid: {
            top: '6%',
            left: '3%',
            bottom: '0%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                triggerEvent: true,
                boundaryGap: ['10%', '10%'],
                axisLine: {
                    show: false
                },
                axisLabel: {
                    rotate: 25,
                    interval: 0,
                    show: true,
                    color: '#8A93A5'
                },
                axisTick: {
                    show: true,
                    alignWithLabel: true,
                    lineStyle: {
                        color: '#8A93A5'
                    }
                },
                data: (info || []).map(v => v.name)
            }
        ],
        yAxis: [
            {
                type: 'value',
                min: 0,
                minInterval: 1,
                splitNumber: 6,
                axisLabel: {
                    show: true,
                    color: '#8A93A5'
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: true,
                    color: '#8A93A5'
                }
            }
        ],
        series: [{
            name: '党派分布',
            type: 'bar',
            barCategoryGap: '60%',
            data: (info || []).map(v => {
                return {
                    name: v.name,
                    label: v.id,
                    value: parseInt(v.value),
                    itemStyle: {
                        barBorderRadius: [50, 50, 0, 0],
                        shadowColor: 'rgba(0, 0, 0, 0.4)',
                        shadowBlur: 6,
                        color: v.color
                    }
                }
            })
        }]
    }
}

/**
 * 受益人数图
 * @param info
 */
function generateBenefitChart(info) {
    let names1 = [], names2 = [], data1 = [], data2 = []
    if (info) {
        for (let i = 0; i < info.length; i++) {
            names1.push({ icon: 'circle', name: info[i].name })
            let data = { value: 0, name: info[i].name, itemStyle: { color: info[i].color } }
            for (let j = 0; j < info[i].value.length; j++) {
                names2.push({ icon: 'circle', name: info[i].value[j].name })
                data2.push({
                    value: info[i].value[j].value,
                    name: info[i].value[j].name,
                    itemStyle: { color: info[i].value[j].color }
                })
                data.value += info[i].value[j].value
            }
            data1.push(data)
        }
    }
    return {
        backgroundColor: '#FFF',
        tooltip: {
            trigger: 'item',
            formatter: "{b}：{c}人 ({d}%)"
        },
        legend: [{
            x: 'right',
            y: '10%',
            align: 'left',
            selectedMode: true,
            orient: 'vertical',
            formatter: (name) => {
                let obj = data1.filter(o => o.name === name) || [{ value: 0 }]
                return `${name}：${app.IntegerFormat(obj[0].value)}人`
            },
            data: names1
        }, {
            x: 'center',
            y: 'bottom',
            align: 'left',
            selectedMode: true,
            formatter: (name) => {
                let obj = data2.filter(o => o.name === name) || [{ value: 0 }]
                return `${name}：${app.IntegerFormat(obj[0].value)}人`
            },
            data: names2
        }],
        series: [
            {
                name: '受益人数',
                type: 'pie',
                radius: [0, '25%'],
                center: ['40%', '30%'],
                stillShowZeroSum: false,
                label: {
                    show: false,
                    position: 'inner',
                    formatter: `{b}\n{d}%`
                },
                labelLine: {
                    show: false
                },
                itemStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                },
                data: data1
            },
            {
                name: '受益人数',
                type: 'pie',
                radius: ['35%', '55%'],
                center: ['40%', '30%'],
                stillShowZeroSum: false,
                label: {
                    show: false,
                    formatter: (params) => `${params.name}：${app.IntegerFormat(params.value)}人`
                },
                labelLine: {
                    smooth: .2
                },
                itemStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                },
                data: data2
            }
        ]
    }
}

/**
 * 出勤人次图
 * @param info
 * @returns {{}}
 */
function generateAttendanceChart(info) {
    const colors = gradientColor([169, 231, 227], [10, 83, 78], (info ? info.length : 0))
    return {
        backgroundColor: '#fff',
        tooltip: {
            trigger: 'item',
        },
        series: [
            {
                name: '出勤人次',
                type: 'pie',
                radius: '50%',
                center: ['50%', '50%'],
                stillShowZeroSum: false,
                data: (info || []).sort(function (a, b) {
                    return a.value - b.value
                }),
                // minShowLabelAngle: 1,
                roseType: 'angle',
                label: {
                    textStyle: {
                        color: '#8A93A5'
                    }
                },
                labelLine: {
                    lineStyle: {
                        color: '#8A93A5'
                    },
                    smooth: .2,
                },
                itemStyle: {
                    color: ({ dataIndex }) => {
                        return colors[dataIndex]
                    },
                    shadowBlur: 20,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        ]
    }
}

/**
 * 职能分布图
 * @param info
 */
function generatePpeChart(info, max) {
    return {
        backgroundColor: '#fff',
        tooltip: {
            show: true,
            trigger: 'item',
            formatter: (params) => {
                let text = params.dataIndex === 0 ? '男性人数\n' : '女性人数\n'
                for (let i = 0; i < info.length; i++) {
                    text += `${info[i].name}：${params.data.value[i]}人\n`
                }
                return text
            },
            extraCssText: 'white-space:pre-wrap'
        },
        legend: {
            x: 'center',
            y: 'bottom',
            data: [
                { name: '男性', icon: 'circle' },
                { name: '女性', icon: 'circle' }
            ]
        },
        radar: {
            indicator: (info || []).map(v => ({ name: v.name, max: v.total || 0 })),
            name: {
                color: '#1890ff',
                formatter: (value) => {
                    let d = info.filter(v => v.name === value) || [{ total: 0 }]
                    return `${value}\n${app.IntegerFormat(d[0].total)}人`
                },
                textShadowBlur: 10,
                textShadowColor: 'rgba(0, 0, 0, 0.2)'
            },
            triggerEvent: true,
            center: ['50%', '40%'],
            radius: '50%',
            splitArea: {
                show: true,
                areaStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0, 0, 0, 0.2)'
                }
            },
            splitLine: {},
        },
        series: [{
            type: 'radar',
            data: [
                {
                    value: (info || []).map(v1 => v1.men_total),
                    name: '男性',
                    lineStyle: {
                        color: '#1BADED',
                        width: 3,
                        shadowBlur: 6,
                        shadowColor: 'rgba(0, 0, 0, 0.2)'
                    },
                    label: { show: false },
                    itemStyle: {
                        color: '#1BADED',
                        shadowBlur: 6,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.2)'
                    },
                },
                {
                    value: (info || []).map(v1 => v1.women_total),
                    name: '女性',
                    lineStyle: {
                        color: '#FFA8E0',
                        width: 3,
                        shadowBlur: 6,
                        shadowColor: 'rgba(0, 0, 0, 0.2)'
                    },
                    label: { show: false },
                    itemStyle: {
                        color: '#FFA8E0',
                        shadowBlur: 6,
                        borderWidth: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.2)'
                    },
                }
            ]
        }]
    }
}

/**
 * 队伍基础装备图
 * @param info
 */
function generateEquipChart(info) {
    return {
        backgroundColor: '#fff',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'line'
            }
        },
        grid: {
            left: '6%',
            right: '3%',
            top: '6%',
            bottom: '40%'
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
                show: true,
                color: '#8A93A5',
                rotate: 45,
                interval: 0,
                formatter: (name) => {
                    if (name.length > 16) {
                        return name.substr(0, 16) + '...'
                    }
                    return name
                }
            },
            axisLine: {
                lineStyle: {
                    color: '#8A93A5'
                }
            },
            axisTick: {
                color: '#8A93A5'
            },
            data: (info || []).map(v => v.name)
        },
        yAxis: {
            min: 0,
            type: 'value',
            minInterval: 1,
            boundaryGap: ['20%', '20%'],
            axisLine: {
                lineStyle: {
                    color: '#8A93A5'
                }
            },
            axisTick: {
                color: '#8A93A5'
            },
            axisLabel: {
                show: true,
                color: '#8A93A5'
            },
            splitLine: {
                lineStyle: {
                    color: 'rgba(138,147,165,0.4)'
                }
            }
        },
        series: [{
            data: (info || []).map(v => v.value),
            type: 'line',
            itemStyle: {
                color: 'rgba(24,144,255,1)'
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(24,144,255,0.9)'
                }, {
                    offset: 1,
                    color: 'rgba(24,144,255,0.4)'
                }])
            },
            lineStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 0, 0, 0.6)'
            }
        }]
    }
}

/**
 * 生成圆形柱形图表
 */
function generateMiltipYZChart(info = [], max) {
    let names = (info || []).map(t => t.name)
    let options = {
        tooltip: {
            trigger: 'item',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: '{a}：{c}次'
        },
        legend: {
            show: true,
            left: 'center',
            top: '60%',
            orient: 'vertical',
            data: (info || []).map(t => {
                return { name: t.name, icon: 'pin' }
            }),
            formatter: (name) => {
                let obj = info.filter(o => o.name === name) || [{ value: 0 }]
                return `${name}：${obj[0].value}次`
            }
        },
        angleAxis: {
            show: false,
            max: max,
        },
        radiusAxis: {
            type: 'category',
            data: names,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: false
            }
        },
        polar: { radius: '60%', center: ['50%', '30%'] },
        series: (info || []).map((t, i) => {
            let data = []
            for (let j = 0; j < info.length; j++) {
                if (j === i) data.push(parseInt(t.value))
                else data.push(0)
            }
            return {
                name: t.name,
                data: data,
                type: 'bar',
                coordinateSystem: 'polar',
                stack: 'a',
                itemStyle: {
                    color: t.color,
                    shadowBlur: 20,
                    shadowColor: 'rgba(0, 0, 0, 0.2)'
                }
            }
        }),
    }
    return options
}

/**
 * 无数据
 * @param msg
 * @returns {*}
 */
function notDataNode(height, msg = '暂无数据') {
    return (
        <div className="no-data" style={{ height: height + 'px', lineHeight: height + 'px' }}>
            <Icon type="info-circle" />
            <span className="no-data-text">{msg}</span>
        </div>
    )
}

class BData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data_loading: true,
            sexOptions: {},
            mapOptions: {},
            ppeOptions: [],
            ageMenOptions: {},
            benefitOptions: {},
            attendanceOptions: {},
            activityOptions: [],
            ageWomenOptions: {},
            politicsOptions: {},
            departureOptions: {},
            equipOptions: {},
            distributionOptions: {},
            serviceLengthOptions: {},
            filter: {
                type: 1,
                mark: "全国",
                province: "中国"
            },
            info: {
                age_distribution: {}
            },
            players_modal_visible: false,
            players_modal_title: '',
            players_modal_loading: true,
            player_ids: [],
            players: [],
            pm_total: 0,
            pm_page: 1,
        }
    }

    setData = (data) => app.setStateSync(this, data)

    async componentDidMount() {
        this._isMounted = true
        window.onresize = function () {
            for (let i = 0; i < charts.length; i++) {
                charts[i].resize()
            }
        }
        this.a = 1
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 数据
     * @returns {Promise<void>}
     */
    dataSource = async (filter) => {
        await this.setData({ filter, data_loading: true })
        let { flag, data, msg } = await app.post(api.CatDataNew, {
            type: filter.type,
            mark: filter.mark
        })
        const state = { data_loading: false }
        if (flag === 1) {
            state.politicsOptions = generatePartyChart(data.party_member_distribution)
            state.distributionOptions = generateSexMiltipleStripChart(data.identity_distribution, 'right')
            state.sexOptions = generateSolidCircleChart(data.sex_distribution, '人')
            state.serviceLengthOptions = generateXBarChart(data.duration)
            state.departureOptions = generateSingleLineChart(data.departure)
            let a_c_i = 0, a_max_value = 0
            if (data.activity) {
                for (let i = 0; i < data.activity.length; i++) {
                    for (let j = 0; j < data.activity[i].length; j++) {
                        // data.activity[i][j].color = colors[a_c_i]
                        if (a_max_value < data.activity[i][j].value) {
                            a_max_value = data.activity[i][j].value
                        }
                        a_c_i++
                    }
                }
            }
            state.activityOptions = (data.activity || []).map(a => {
                return generateMiltipYZChart(a, a_max_value)
            })
            state.benefitOptions = generateBenefitChart(data.benefit)
            state.attendanceOptions = generateAttendanceChart(data.attendance)
            state.equipOptions = generateEquipChart(data.equip)
            let ad_len = 0;
            if (data.age_distribution) {
                ad_len = data.age_distribution.men.length;
            }
            let adm_total = 0, adw_total = 0
            if (data.age_total && data.age_total > 0) {
                for (let i = 0; i < ad_len; i++) {
                    adm_total += data.age_distribution.men[i].value
                    adw_total += data.age_distribution.women[i].value
                }
            }
            let adm_lv = 0, adw_lv = 0
            for (let i = 0; i < ad_len; i++) {
                if (i === ad_len - 1) {
                    if (adm_total) {
                        data.age_distribution.men[i].lv = (100 - adm_lv).toFixed(2)
                    } else {
                        data.age_distribution.men[i].lv = 0
                    }
                    if (adw_total) {
                        data.age_distribution.women[i].lv = (100 - adw_lv).toFixed(2)
                    } else {
                        data.age_distribution.women[i].lv = 0
                    }
                } else {
                    if (adm_total) {
                        let aml = Math.floor(data.age_distribution.men[i].value / adm_total * 10000) / 100
                        data.age_distribution.men[i].lv = aml
                        adm_lv += aml
                    } else {
                        data.age_distribution.men[i].lv = 0
                    }

                    if (adw_total) {
                        let awl = Math.floor(data.age_distribution.women[i].value / adw_total * 10000) / 100
                        data.age_distribution.women[i].lv = awl
                        adw_lv += awl
                    } else {
                        data.age_distribution.women[i].lv = 0
                    }
                }
            }
            let ppe_data = data.ppe_nember, ppe_len = ppe_data ? ppe_data.length : 0, ppe_sl = ppe_len, ppe_max = 0
            if (ppe_data) {
                for (let i = 0; i < ppe_data.length; i++) {
                    if (ppe_data[i].men_total > ppe_max) {
                        ppe_max = ppe_data[i].men_total
                    }
                    if (ppe_data[i].women_total > ppe_max) {
                        ppe_max = ppe_data[i].women_total
                    }
                }
            }
            if (ppe_len <= 10) {
                data = [generatePpeChart(ppe_data, ppe_max)]
            } else if (ppe_len <= 20) {
                ppe_sl = parseInt(ppe_len / 2)
                if (ppe_len % 2 !== 0) {
                    ppe_sl += 1
                }
                state.ppeOptions = [generatePpeChart(ppe_data.slice(0, ppe_sl), ppe_max), generatePpeChart(ppe_data.slice(ppe_sl), ppe_max)]
            } else if (ppe_len <= 30) {
                ppe_sl = parseInt(ppe_len / 3)
                if (ppe_len % 3 !== 0) {
                    ppe_sl += 1
                }
                data = [generatePpeChart(ppe_data.slice(0, ppe_sl), ppe_max), generatePpeChart(ppe_data.slice(ppe_sl, ppe_sl * 2), ppe_max), generatePpeChart(ppe_data.slice(ppe_sl * 2), ppe_max)]
            }
            if (provinces.indexOf(filter.province) !== -1) {
                state.mapOptions = generateMapChart(filter.province)
            } else {
                state.mapOptions = generateMapChart('中国')
            }
            state.info = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 表格条件变更
     * @param pagination
     * @param filters
     */
    // handleTableChange = (pagination, filters) => {
    //     console.log(filters)
    // };

    /**
     * 队员列表数据加载
     * @param page
     * @returns {Promise<void>}
     */
    playersSource = async (page = 1) => {
        await this.setData({ mp_page: page, players_modal_loading: true })
        const { player_ids } = this.state
        let { flag, data, msg } = await app.post(api.CatDataNewUser, { uid: player_ids })
        const state = { players_modal_loading: false }
        if (flag === 1) {
            state.players = utils.addArrayKey(data)
        } else {
            app.alert(msg, "error")
        }
        if (page === this.state.mp_page) {
            await this.setData(state)
        }
    }

    /**
     * 窗口大小变化
     * @param func
     */
    handleResize = (func) => {
        if (charts.findIndex((c) => c.id === func.id) === -1) {
            charts.push(func)
        }
    }

    /**
     * 筛选变更
     * @param res
     */
    handleFilterChange = async (filter) => {
        // console.log(filter)
        await this.dataSource(filter)
    }

    /**
     * 关闭队员列表对话框
     */
    handleClosePlayersModal = () => {
        this.setData({ players_modal_visible: false })
    }

    /**
     * 党员图表点击事件
     **/
    handlePoliticsClick = async (params) => {
        if (this.state.players_modal_visible) return
        const { info, filter } = this.state
        let party = [], name = ''
        switch (params.componentType) {
            case 'series':
                party = info.party_member_distribution.find(p => p.id === params.data.label)
                name = params.data.name
                break
            case 'xAxis':
                name = params.value
                party = info.party_member_distribution.find(p => p.name === name)
                break
            default:
                return false
        }
        if (!party) return
        if (!party.list) {
            app.alertDestroy()
            app.alert(`${name}下暂无人员`, 'warn')
            return
        }
        await this.setData({
            players: [],
            pm_page: 1,
            pm_total: 0,
            player_ids: party.list,
            players_modal_title: `【${filter.title}】党员分布【${name}】列表`,
            players_modal_visible: true
        })
        await this.playersSource()
    }

    /**
     * 技能图表点击事件
     **/
    handlePpeChartClick = (params) => {
        if (params.componentType !== 'radar' || this.state.players_modal_visible) return true
        const { info, filter } = this.state, name = params.name.split('\n')[0],
            ppe = info.ppe_nember.find(p => p.name === name)
        if (!ppe) return true
        if (!ppe.total) {
            app.alertDestroy()
            app.alert(`${name}下暂无人员`, 'warn')
            return true
        }
        Modal.destroyAll()
        let select_sex = '1'
        Modal.confirm({
            title: `查看【${name}】人员`,
            content: (
                <RadioGroup onChange={(e) => {
                    select_sex = e.target.value
                }} defaultValue="1">
                    <Radio style={{ display: 'block' }} value="1">全部（{ppe.total}人）</Radio>
                    <Radio style={{ display: 'block', margin: '.5rem 0' }} value="2"
                        disabled={!ppe.women_total}>女性（{ppe.women_total}人）</Radio>
                    <Radio style={{ display: 'block' }} value="3" disabled={!ppe.men_total}>男性（{ppe.men_total}人）</Radio>
                </RadioGroup>
            ),
            centered: true,
            okText: '查看',
            cancelText: '取消',
            onOk: async () => {
                let sexName = '全部', player_ids = ppe.men_list
                switch (select_sex) {
                    case '2':
                        sexName = '女性'
                        player_ids = ppe.women_list
                        break
                    case '3':
                        sexName = '男性'
                        player_ids = ppe.men_list
                        break
                    default:
                        sexName = '全部'
                        if (ppe.women_total > 0) {
                            player_ids += (',' + ppe.women_list)
                        }
                        break
                }
                if (!player_ids) {
                    app.alert('暂无队员', 'warn')
                    return
                }
                await this.setData({
                    players: [],
                    pm_page: 1,
                    pm_total: 0,
                    player_ids,
                    players_modal_title: `【${filter.title}】存心人员技能分布【${name}】${sexName}队员列表`,
                    players_modal_visible: true
                })
                await this.playersSource()
            }
        })
    }

    /**
     * 队员列表换页点击事件
     **/
    handlePlayersChangePage = async (page) => {
        await this.setData({ pm_page: page })
    }

    render() {
        let {
            data_loading, info, filter, politicsOptions, distributionOptions, sexOptions, mapOptions, ppeOptions, departureOptions, serviceLengthOptions,
            benefitOptions, attendanceOptions, equipOptions, activityOptions, players_modal_visible, players_modal_title, players, players_modal_loading, pm_total,
            pm_page
        } = this.state,
            players_columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '20%',
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '15%',
                },
                {
                    title: '所属队伍',
                    dataIndex: 'team',
                    key: 'team',
                    width: '30%',
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: '10%',
                    // filters: [{ text: '男', value: '男' }, { text: '女', value: '女' }],
                },
                {
                    title: '队员身份',
                    dataIndex: 'volunteer_state',
                    key: 'volunteer_state',
                    width: '15%',
                    render: (vs) => vs || '暂无'
                },
            ],
            fType = checkType(filter.type)
        return (
            <div className="page">
                <div className="big-data-page">
                    <div className="page-title">存心大数据</div>
                    <div className="page-content">
                        <BigDataFilter change={this.handleFilterChange} />
                        {
                            data_loading ? (
                                <div className="pc-loading">
                                    <Spin indicator={<Icon type="loading" style={{ fontSize: '2rem' }} spin />} />
                                    <div className="pcl-text">数据正在加载中，请耐心等候 ......</div>
                                </div>
                            ) : null
                        }
                        <div className="charts" style={{ visibility: data_loading ? 'hidden' : 'visible' }}>
                            <div className="chart c-730 c-mr">
                                <div className="c-title">已选择：{filter.title}</div>
                                <Row>
                                    <Col span={12}>
                                        <div className="team-legends info-data">
                                            <Row className="tl-items">
                                                <Col className="tl-item" span={12}>
                                                    <div className="tli-title">总人数</div>
                                                    <div className="tli-content">
                                                        <Statistic value={info.total_people}></Statistic>人
                                                    </div>
                                                </Col>
                                                <Col className="tl-item" span={12}>
                                                    <div className="tli-title">已认证人数</div>
                                                    <div className="tli-content">
                                                        <Statistic value={info.verify_number}></Statistic>人
                                                    </div>
                                                </Col>
                                                <Col className="tl-item" span={8}>
                                                    <div className="tli-title">年内入队人数</div>
                                                    <div className="tli-content">
                                                        <Statistic value={info.year_team_number}></Statistic>人
                                                    </div>
                                                </Col>
                                                <Col className="tl-item" span={8}>
                                                    <div className="tli-title">离队人数</div>
                                                    <div className="tli-content">
                                                        <Statistic value={info.leave_team_number}></Statistic>人
                                                    </div>
                                                </Col>
                                                <Col className="tl-item" span={8}>
                                                    <div className="tli-title">清退人数</div>
                                                    <div className="tli-content">
                                                        <Statistic value={info.expel_team_number}></Statistic>人
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="line" />
                                            <Row className="tl-items">
                                                {
                                                    (info.team_number || []).map((tn, i) => {
                                                        return (
                                                            <Col className="tl-item" key={i} span={8}>
                                                                <div className="tli-title">{tn.name}</div>
                                                                <div className="tli-content">
                                                                    <Statistic value={tn.value}></Statistic>支
                                                                </div>
                                                            </Col>
                                                        )
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col span={12} className="">
                                        {/*<ul className="c-date-filter">*/}
                                        {/*<li>年度</li>*/}
                                        {/*<li>半年</li>*/}
                                        {/*<li>季度</li>*/}
                                        {/*<li>当月</li>*/}
                                        {/*<li className="cdf-sel">当日</li>*/}
                                        {/*</ul>*/}
                                        <BarReact option={mapOptions} clear={true} height={316}
                                            resize={this.handleResize} />
                                    </Col>
                                </Row>
                            </div>
                            <div className="chart c-360">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>服务时长</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.duration_total}></Statistic>时</Col>
                                </Row>
                                {
                                    info.duration_total ? (
                                        <BarReact option={serviceLengthOptions} height={316}
                                            resize={this.handleResize} />
                                    ) : notDataNode(316)
                                }
                            </div>
                            <div className="chart c-360 c-mr">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>工作统计状况</Col>
                                    <Col className="c-subtext">总数：<Statistic value={info.departure_total}></Statistic>次</Col>
                                </Row>
                                {
                                    info.departure_total ? (
                                        <BarReact option={departureOptions} height={316}
                                            resize={this.handleResize} />
                                    ) : notDataNode(316)
                                }
                            </div>
                            <div className="chart c-730">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>党派分布</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.party_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.party_total ? (
                                        <BarReact option={politicsOptions} height={316} click={this.handlePoliticsClick}
                                            resize={this.handleResize} />) : notDataNode(316)
                                }
                            </div>
                            <div className="chart c-block acivity-charts">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>年度活动数据</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.activity_total}></Statistic>次</Col>
                                </Row>
                                {info.activity_total ? activityOptions.map((a, i) => {
                                    return (
                                        <div key={i} className="ac-item"
                                            style={{ width: `${100 / activityOptions.length}%` }}>
                                            <BarReact option={a} height={344}
                                                resize={this.handleResize} />
                                        </div>
                                    )
                                }) : notDataNode(344)}
                            </div>
                            <div className="chart c-730 c-mr">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>年度受益人数</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.benefit_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.benefit_total ? (
                                        <BarReact option={benefitOptions} height={360} resize={this.handleResize} />
                                    ) : notDataNode(360)
                                }
                            </div>
                            <div className="chart c-360">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>年度出勤人次</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.attendance_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.attendance_total ? (
                                        <BarReact option={attendanceOptions} height={360} resize={this.handleResize} />)
                                        : notDataNode(360)
                                }
                            </div>
                            <div className="chart c-block">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>技能分布</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.ppe_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.ppe_total ? ppeOptions.map((p, i) => {
                                        return (
                                            <div key={i} className="pc-item"
                                                style={{ width: `${100 / ppeOptions.length}%`, float: 'left' }}>
                                                <BarReact option={p} height={316} click={this.handlePpeChartClick}
                                                    resize={this.handleResize} />
                                            </div>
                                        )
                                    }) : notDataNode(316)
                                }
                            </div>
                            <div className="chart c-block">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>队伍基础装备</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.equip_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.equip_total ? (
                                        <BarReact option={equipOptions} height={360} resize={this.handleResize} />)
                                        : notDataNode(360)
                                }
                            </div>
                            <div className="chart c-360 c-mr">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>男女年龄分布</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.age_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.age_total ? (
                                        <div className="sex_age_charts">
                                            <div className="sac-item">
                                                <div className="sac-title">男性年龄分布</div>
                                                <div className="sac-chart">
                                                    {
                                                        (info.age_distribution.men || []).map((m, i) => {
                                                            return (
                                                                <div className="sacc-item"
                                                                    style={{ width: m.lv + '%', backgroundColor: m.color }}
                                                                    key={i} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <div className="sac-legend">
                                                    {
                                                        (info.age_distribution.men || []).map((m, i) => {
                                                            return (
                                                                <div className="sacl-item" key={i}>
                                                                    <div className="sacl-icon"
                                                                        style={{ backgroundColor: m.color }} />
                                                                    <div
                                                                        className="sacl-text">{`${m.name}：${m.value}人（${m.lv}%）`}</div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            <div className="sac-item">
                                                <div className="sac-title">女性年龄分布</div>
                                                <div className="sac-chart">
                                                    {
                                                        (info.age_distribution.women || []).map((m, i) => {
                                                            return (
                                                                <div className="sacc-item"
                                                                    style={{ width: m.lv + '%', backgroundColor: m.color }}
                                                                    key={i} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <div className="sac-legend">
                                                    {
                                                        (info.age_distribution.women || []).map((m, i) => {
                                                            return (
                                                                <div className="sacl-item" key={i}>
                                                                    <div className="sacl-icon"
                                                                        style={{ backgroundColor: m.color }} />
                                                                    <div
                                                                        className="sacl-text">{`${m.name}：${m.value}人（${m.lv}%）`}</div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ) : notDataNode(360)
                                }
                            </div>
                            <div className="chart c-360 c-mr">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>性别比例</Col>
                                    <Col className="c-subtext">总数：<Statistic
                                        value={info.sex_total}></Statistic>人</Col>
                                </Row>
                                {
                                    info.sex_total ? (
                                        <BarReact option={sexOptions} height={360} resize={this.handleResize} />)
                                        : notDataNode(360)
                                }
                            </div>
                            <div className="chart c-360">
                                <Row className="c-title" type="flex" justify="space-between">
                                    <Col>男女身份分布</Col>
                                    <Col className="c-subtext">
                                        总数：<Statistic value={info.identity_distribution_total}></Statistic>人
                                    </Col>
                                </Row>
                                {
                                    info.identity_distribution_total ? (
                                        <BarReact option={distributionOptions} height={360} resize={this.handleResize} />)
                                        : notDataNode(360)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={players_modal_visible}
                    footer={null}
                    title={players_modal_title}
                    maskClosable={false}
                    centered={true}
                    width='60vw'
                    bodyStyle={{ height: 'calc(80vh - 55px)', overflow: 'auto', padding: 10 }}
                    zIndex={9999}
                    onCancel={this.handleClosePlayersModal}
                >
                    <Table
                        size="small"
                        locale={app.tbLocale(players_modal_loading)}
                        columns={players_columns}
                        dataSource={players}
                        loading={players_modal_loading}
                        // onChange={this.handleTableChange}
                        pagination={{
                            total: pm_total,
                            current: pm_page,
                            pageSize: 100,
                            showTotal: (t) => `共${t}人`,
                            onChange: this.handlePlayersChangePage
                        }}
                        scroll={{ y: 'calc(80vh - 170px)' }}
                    />
                </Modal>
            </div>
        )
    }
}

export default BData



// WEBPACK FOOTER //
// ./src/routes/bigData/BData.jsx